import { SCOPES } from './../../../../services/scope/scope-constants';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CancellationReasonsListComponent } from "../../../../components/admin-dashboard-component/cancellation-reasons-component/cancellation-reasons-list-component/cancellation-reasons-list-component";
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';
import { ScopeService } from '../../../../services/scope/scope-service';

@Component({
  selector: 'app-cancellation-reasons-list',
  imports: [RouterModule, CancellationReasonsListComponent , HasScopeDirective],
  templateUrl: './cancellation-reasons-list.html',
  styleUrl: './cancellation-reasons-list.scss',
})
export class CancellationReasonsList {
readonly SCOPES = SCOPES;
}
